/* Generated by tools/migration/src/export-shop-static.mjs — legacy skin-type taxonomy snapshot.
 * Keys are product handles (legacy slugs); values are skin-type slugs.
 * Regenerate while the legacy database is reachable; safe to hand-edit after shutdown. */
window.MS_SHOP_SKIN = {
 "chando-himalaya-astaxanthin-ampoule-mask-15ml-33ml-5": [
  "all-skin-types"
 ],
 "chando-himalaya-astaxanthin-lifting-mask-26ml-5": [
  "aging-skin"
 ],
 "chando-himalaya-crystal-clear-cleanser-110-g": [
  "combination-skin",
  "dry-skin",
  "sensitive-skin"
 ],
 "chando-himalaya-crystal-white-emulsion-120-ml": [
  "aging-skin",
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin",
  "skin-with-dark-spots"
 ],
 "chando-himalaya-crystal-white-facial-cream-50gr": [
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin"
 ],
 "chando-himalaya-crystal-white-spot-targeting-serum-30-ml": [
  "skin-with-dark-spots"
 ],
 "chando-himalaya-crystal-white-toner-160-ml": [
  "aging-skin",
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin",
  "skin-with-dark-spots"
 ],
 "chando-himalaya-extravagance-rejuvenation-collagen-cream-55-gr": [
  "aging-skin"
 ],
 "chando-himalaya-extravagance-rejuvenation-collagen-emulsion-110ml": [
  "all-skin-types"
 ],
 "chando-himalaya-extravagance-rejuvenation-collagen-essence-lotion-200ml": [
  "all-skin-types"
 ],
 "chando-himalaya-extravagance-rejuvenation-collagen-serum-50ml": [
  "all-skin-types"
 ],
 "chando-himalaya-extravagance-rejuvenation-eye-cream-20-gr": [
  "all-skin-types"
 ],
 "chando-himalaya-glossy-hydrating-lip-stain-007-orange-24-ml": [
  "all-skin-types"
 ],
 "chando-himalaya-gold-diamond-active-reviving-clarifying-cleanser-200-ml": [
  "all-skin-types"
 ],
 "chando-himalaya-gold-diamond-anti-wrinkle-micro-sculpting-emulsion-110-ml": [
  "aging-skin"
 ],
 "chando-himalaya-gold-diamond-multi-anti-aging-cream-50-gr": [
  "aging-skin"
 ],
 "chando-himalaya-gold-diamond-multi-anti-aging-essence-50-ml": [
  "aging-skin"
 ],
 "chando-himalaya-gold-diamond-multi-anti-aging-eye-cream": [
  "aging-skin",
  "all-skin-types"
 ],
 "chando-himalaya-gold-diamond-ultra-vitalizing-micro-sculpting-essence-lotion-200ml": [
  "all-skin-types"
 ],
 "chando-himalaya-green-tea-clay-purifying-mask-100-gr": [
  "all-skin-types"
 ],
 "chando-himalaya-himalayan-essence-330ml-110ml": [
  "all-skin-types"
 ],
 "chando-himalaya-moisturizing-repair-mask-28ml-5": [
  "all-skin-types"
 ],
 "chando-himalaya-multi-protection-suncare-lotion-spf50-pa-50-gr": [
  "aging-skin",
  "all-skin-types",
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin"
 ],
 "chando-himalaya-niacinamide-ampoule-mask-15ml-33ml-5": [
  "all-skin-types"
 ],
 "chando-himalaya-niacinamide-brightening-mask-26ml-5": [
  "all-skin-types"
 ],
 "chando-himalaya-rejuvenation-repairing-essence-50-ml": [
  "all-skin-types"
 ],
 "chando-himalaya-rejuvenation-repairing-essence-cream-55-gr": [
  "all-skin-types"
 ],
 "chando-himalaya-rejuvenation-repairing-essence-emulsion-150-ml": [
  "all-skin-types"
 ],
 "chando-himalaya-rejuvenation-repairing-essence-toner-110-gr": [
  "all-skin-types"
 ],
 "chando-himalaya-salicylic-acid-oil-control-anti-acne-essence-40-ml": [
  "all-skin-types",
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin"
 ],
 "chando-himalaya-salicylic-acid-oil-control-anti-acne-toner-150-ml": [
  "all-skin-types",
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin",
  "skin-with-dark-spots"
 ],
 "chando-himalaya-soft-touch-matte-lipstick-r11-ruby-32-gr": [
  "all-skin-types"
 ],
 "chando-himalaya-soothing-moisturizing-amino-acid-cleanser-120-ml": [
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin",
  "skin-with-dark-spots"
 ],
 "chando-himalaya-soothing-moisturizing-cream-55-gr": [
  "all-skin-types"
 ],
 "chando-himalaya-soothing-moisturizing-emulsion-110-ml": [
  "aging-skin",
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin",
  "skin-with-dark-spots"
 ],
 "chando-himalaya-soothing-moisturizing-essence-45-ml": [
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "skin-with-dark-spots"
 ],
 "chando-himalaya-soothing-moisturizing-toner-160-ml": [
  "aging-skin",
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin",
  "skin-with-dark-spots"
 ],
 "chando-himalaya-soothing-ultra-moisturizing-cream-55gr": [
  "dry-skin"
 ],
 "chando-himalaya-triple-collagen-anti-wrinkle-single-use-essence-12ml30": [
  "aging-skin"
 ],
 "chando-himalaya-truffle-illuminating-cushion-foundation-12g2": [
  "all-skin-types"
 ],
 "chando-himalaya-truffle-illuminating-foundation-b01-porcelain-30ml": [
  "all-skin-types"
 ],
 "chando-himalaya-uv-protection-water-and-sweat-resistant-sunscreen-50-gr": [
  "aging-skin",
  "all-skin-types",
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin"
 ],
 "clarifying-hydrating-acne-care-set": [
  "aging-skin",
  "combination-skin",
  "dry-skin",
  "skin-with-dark-spots"
 ],
 "holiday-travel-kit": [
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin",
  "skin-with-dark-spots"
 ],
 "osm-amino-acid-moisturizing-mask-25ml-5-sheets": [
  "dry-skin",
  "sensitive-skin"
 ],
 "osm-collagen-firming-and-repairing-essence-12mlx30": [
  "aging-skin",
  "combination-skin",
  "dry-skin"
 ],
 "osm-cool-oil-control-radiant-cleanser-120gr": [
  "oily-skin"
 ],
 "osm-gold-honey-renewal-mask-30ml-5-sheets": [
  "dry-skin",
  "sensitive-skin"
 ],
 "osm-gold-renewal-travel-set-mask-30ml-5": [
  "aging-skin"
 ],
 "osm-high-end-anti-aging-set": [
  "aging-skin",
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin",
  "skin-with-dark-spots"
 ],
 "osm-hydroenergy-moisturizing-cleanser-120ml": [
  "combination-skin"
 ],
 "osm-hydroenergy-moisturizing-emulsion-50ml": [
  "combination-skin",
  "oily-skin"
 ],
 "osm-hydroenergy-moisturizing-essence-150ml": [
  "combination-skin",
  "oily-skin"
 ],
 "osm-hydroenergy-moisturizing-essence-cream-50gr": [
  "dry-skin"
 ],
 "osm-isolating-and-brightening-sunproof-emulsion-spf50-pa-50gr": [
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin",
  "skin-with-dark-spots"
 ],
 "osm-lucent-brightening-whitening-cream-50gr": [
  "combination-skin",
  "dry-skin",
  "skin-with-dark-spots"
 ],
 "osm-lucent-brightening-whitening-cream-8-gr": [
  "combination-skin",
  "oily-skin",
  "skin-with-dark-spots"
 ],
 "osm-lucent-brightening-whitening-essence-30ml": [
  "combination-skin",
  "dry-skin",
  "skin-with-dark-spots"
 ],
 "osm-lucent-brightening-whitening-fresh-lotion-150ml": [
  "combination-skin",
  "dry-skin",
  "skin-with-dark-spots"
 ],
 "osm-lucent-brightening-whitening-lotion-20-ml": [
  "skin-with-dark-spots"
 ],
 "osm-lucent-shining-whitening-bb-cream-40g": [
  "combination-skin",
  "dry-skin",
  "skin-with-dark-spots"
 ],
 "osm-luxury-golden-facial-cleanser-120ml": [
  "aging-skin",
  "combination-skin",
  "oily-skin"
 ],
 "osm-men-hydroenergy-moisturizing-kit": [
  "combination-skin",
  "dry-skin"
 ],
 "osm-niacinamide-brightening-mask-25ml-5-sheets": [
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-centella-asiatica-soothing-repair-mask-25ml-5-sheets": [
  "dry-skin",
  "sensitive-skin"
 ],
 "osm-pearl-firm-brighten-massage-eye-cream-20ml": [
  "aging-skin",
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-gold-ha-youth-mask-30ml-5-sheets": [
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-gold-hyaluronic-acid-travel-set-mask-30ml-5": [
  "dry-skin"
 ],
 "osm-pearl-gold-peptide-lift-mask-30ml-5-sheets": [
  "aging-skin",
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-gold-peptide-whitening-travel-set-mask-3oml-5": [
  "skin-with-dark-spots"
 ],
 "osm-pearl-intelligent-moisture-amino-acid-cleanser-120ml": [
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-intelligent-moisture-amino-acid-cleanser-30-gr": [
  "dry-skin"
 ],
 "osm-pearl-intelligent-moisture-cream-50gr": [
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-intelligent-moisture-emulsion": [
  "dry-skin"
 ],
 "osm-pearl-intelligent-moisture-emulsion-120ml": [
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-intelligent-moisture-emulsion-20ml": [
  "dry-skin"
 ],
 "osm-pearl-intelligent-moisture-essence-35ml": [
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-intelligent-moisture-lotion-160ml": [
  "combination-skin",
  "oily-skin"
 ],
 "osm-pearl-intillegent-moisture-cream-8gr": [
  "dry-skin"
 ],
 "osm-pearl-lucent-brightening-facial-cleanser-120gr": [
  "combination-skin",
  "oily-skin",
  "skin-with-dark-spots"
 ],
 "osm-pearl-lucent-whitening-emulsion-120ml": [
  "combination-skin",
  "dry-skin",
  "skin-with-dark-spots"
 ],
 "osm-pearl-lucent-whitening-emulsion-20ml": [
  "aging-skin",
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin"
 ],
 "osm-pearl-lucent-whitening-eye-cream-5gr": [
  "aging-skin",
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin"
 ],
 "osm-pearl-luxury-golden-lifting-cream-50gr": [
  "aging-skin",
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-luxury-golden-lifting-emulsion-120ml": [
  "aging-skin",
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-luxury-golden-lifting-emulsion-15ml": [
  "aging-skin"
 ],
 "osm-pearl-luxury-golden-lifting-essence-35ml": [
  "aging-skin",
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-luxury-golden-lifting-essence-7ml": [
  "aging-skin"
 ],
 "osm-pearl-luxury-golden-lifting-eye-cream-20gr": [
  "aging-skin",
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-luxury-golden-lifting-eye-cream-5gr": [
  "aging-skin"
 ],
 "osm-pearl-luxury-golden-lifting-lotion-150ml": [
  "aging-skin",
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-luxury-golden-lifting-lotion-20ml": [
  "aging-skin"
 ],
 "osm-pearl-luxury-golden-skincare-set": [
  "aging-skin",
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin",
  "skin-with-dark-spots"
 ],
 "osm-pearl-multi-effect-moisturizing-brightening-mask-25ml-5-pcs": [
  "dry-skin",
  "oily-skin"
 ],
 "osm-pearl-multi-effect-soothing-stabilizing-mask-25ml-5-pcs": [
  "dry-skin",
  "sensitive-skin"
 ],
 "osm-pearl-origin-rejuvenating-cleanser-120ml": [
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-origin-rejuvenating-cleanser-30gr": [
  "combination-skin"
 ],
 "osm-pearl-origin-rejuvenating-cream-50gr": [
  "aging-skin",
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-origin-rejuvenating-cream-8gr": [
  "combination-skin"
 ],
 "osm-pearl-origin-rejuvenating-emulsion-120ml": [
  "aging-skin",
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-origin-rejuvenating-emulsion-15ml": [
  "combination-skin"
 ],
 "osm-pearl-origin-rejuvenating-essence-10ml": [
  "combination-skin"
 ],
 "osm-pearl-origin-rejuvenating-essence-35ml": [
  "aging-skin",
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-origin-rejuvenating-eye-cream-20gr": [
  "aging-skin",
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-origin-rejuvenating-kit": [
  "aging-skin",
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-origin-rejuvenating-lotion-160gr": [
  "aging-skin",
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-origin-rejuvenating-lotion-20gr": [
  "combination-skin"
 ],
 "osm-pearl-origin-rejuvenating-pre-essence-30ml": [
  "aging-skin",
  "combination-skin",
  "dry-skin"
 ],
 "osm-pearl-oxygen-water-moistening-kit-travel-size": [
  "dry-skin"
 ],
 "osm-pearl-radiance-sunscreen-whitening-set": [
  "aging-skin",
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin",
  "skin-with-dark-spots"
 ],
 "osm-pearl-rejuvenating-travel-set": [
  "combination-skin"
 ],
 "osm-pearl-sodium-hyaluronate-moisturizing-mask-25ml-5-sheets": [
  "combination-skin",
  "oily-skin"
 ],
 "osm-pearl-soothing-moisturizing-mask-25ml-5-sheets": [
  "combination-skin",
  "dry-skin",
  "sensitive-skin"
 ],
 "osm-pearl-super-radiant-sun-block-sheer-spf30-pa-40gr": [
  "combination-skin",
  "dry-skin",
  "skin-with-dark-spots"
 ],
 "osm-pearl-whitening-dual-mask2g25ml-x5-sheets": [
  "combination-skin",
  "oily-skin",
  "skin-with-dark-spots"
 ],
 "osm-portulaca-oleracea-soothing-mask-25ml-5-sheets": [
  "combination-skin",
  "oily-skin"
 ],
 "osm-soothing-whitening-essence-12ml30": [
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "sensitive-skin",
  "skin-with-dark-spots"
 ],
 "osm-sunproof-emulsion-spf50pa-50ml": [
  "aging-skin",
  "combination-skin",
  "dry-skin",
  "oily-skin",
  "skin-with-dark-spots"
 ],
 "water-active-smart-moisturizing-gift-box": [
  "aging-skin",
  "combination-skin",
  "dry-skin"
 ],
 "winona-anti-acne-essence-30g": [
  "all-skin-types",
  "skin-with-dark-spots"
 ],
 "winona-anti-acne-paste-18pcs": [
  "all-skin-types"
 ],
 "winona-moisturizing-softening-cream-150g": [
  "all-skin-types"
 ],
 "winona-oil-control-relieving-cleansing-foam-150ml": [
  "all-skin-types"
 ],
 "winona-oil-control-relieving-gel-50g": [
  "all-skin-types"
 ],
 "winona-sensitiveness-relieving-moisturizing-and-soothing-mask": [
  "all-skin-types"
 ],
 "winona-sensitiveness-relieving-moisturizing-tolerance-extreme-cleanser-100g": [
  "dry-skin",
  "sensitive-skin"
 ],
 "winona-sensitiveness-relieving-moisturizing-tolerance-extreme-cream-50g": [
  "sensitive-skin"
 ],
 "winona-sensitiveness-relieving-moisturizing-tolerance-extreme-lotion-120ml": [
  "dry-skin",
  "sensitive-skin"
 ],
 "winona-soothing-extra-care-moisturizing-cream-50g": [
  "all-skin-types",
  "dry-skin"
 ],
 "winona-soothing-moisturizing-cleansing-foam-150ml": [
  "all-skin-types"
 ],
 "winona-soothing-moisturizing-extra-care-essence-30ml": [
  "dry-skin",
  "sensitive-skin"
 ],
 "winona-soothing-repairing-freeze-dried-mask-1pc": [
  "dry-skin",
  "sensitive-skin",
  "skin-with-dark-spots"
 ],
 "winona-soothing-repairing-freeze-dried-mask-6pcs": [
  "aging-skin",
  "dry-skin",
  "sensitive-skin",
  "skin-with-dark-spots"
 ],
 "winona-sunblock-milk-spf48-pa": [
  "all-skin-types"
 ],
 "winona-timeless-repair-sunscreen-milk-50g": [
  "all-skin-types"
 ]
};
